export default __webpack_public_path__ + "static/media/faster.70164edb.webp";